import moment from 'moment';
import * as fetcher from '@hydra/utils/fetcher';

export async function getUserInfo () {
  return fetcher.get('/api/user').json();
}

export const isUserCreatedAfter = (user, date) => {
  const userCreatedDate = user && user.createDate && new Date(user.createDate);
  if (!userCreatedDate) {
    return false;
  }
  const afterDate = new Date(date);
  return afterDate < userCreatedDate;
};

export const getShowExpertNotification = (expertStatus) => {
  const EXPERTSTATUS_INTERESTED = 'INTERESTED';

  if (!expertStatus) {
    return false;
  }
  return expertStatus === EXPERTSTATUS_INTERESTED;
};

export const getIsPdfAllowed = (userInfo) => {
  const allowedReports = userInfo && userInfo.subscription && userInfo.subscription.plan && userInfo.subscription.plan.allowedReports;
  // this logic stems from the past
  // -1 used to mean "infinite amount of reports"
  // we don't support pdf counting anymore so the only valid values are now
  //     0: not allowed
  //    -1: allowed
  return allowedReports === -1;
};

export const checkUserHasActiveSubscription = (userInfo) => {
  if (!userInfo) {
    throw new Error('userInfo required');
  }
  return !!(userInfo && userInfo.subscription && userInfo.subscription.plan);
};

export function isPremium (user) {
  return user &&
    user.subscription &&
    user.subscription.planCode &&
    user.subscription.planCode.includes('prm');
}

export function getIsDudaUser (user) {
  return user &&
    user.subscription &&
    user.subscription.planCode &&
    user.subscription.planCode === 'duda';
}

export function getIsTrial (user) {
  if (!user || !user.subscription) {
    throw new Error('user required');
  }
  const trialStartDate = new Date(user.subscription.trialStartDate);
  const trialEndDate = new Date(user.subscription.trialEndDate);
  const today = new Date();
  return today.getTime() >= trialStartDate && today.getTime() <= trialEndDate;
}

export function getIsInTrialDuda (trialEndDate) {
  if (!trialEndDate) {
    return false;
  }
  const endDate = new Date(trialEndDate);
  const today = new Date();
  return today.getTime() <= endDate;
}

export function calculateTrialDaysLeft (trialEndDate) {
  const today = new Date();
  return moment(trialEndDate).diff(moment(today), 'days') + 1;
}

export function getTempUserPassword () {
  return Math.random().toString(36);
}

export function hasSubUserAccess (user) {
  if (!user) {
    throw new Error('user required');
  }
  return user.masterUserId === 0 && user.subscription?.plan?.allowedSubusers > 0;
}

export function isMasterUser (user) {
  if (!user) {
    throw new Error('user required');
  }
  return user.masterUserId === 0;
}
